import { actionTypes } from "./departmentActionTypes";

const INITIAL_STATE = {
  department: { name: "", notes: "" },
  departmentRecord: [],
  isError: true,
  message: "",
  errors: {},
  saving: false,
  type: "Info",
  Error: false,
  isValidName: false,
  isValidNotes: false,
  isLoading: false,
  isEditDep: false,
  depBtnLoading: false,
  depBtnDisable: false
};
export default function departmentReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.DEP_BTN_LOADING:
      return { ...state, depBtnLoading: action.val };
    case actionTypes.DEP_BTN_DISABLE:
      return { ...state, depBtnDisable: action.val };
    case actionTypes.LOADING_START:
      return { ...state, isLoading: true, message: "" };
    case actionTypes.LOADING_STOP:
      return { ...state, isLoading: false, message: "" };
    case actionTypes.FIELD_STATE_TRUE:
      return { ...state, isValidName: true, isValidNotes: true };
    case actionTypes.IS_EDIT_DEP:
      return { ...state, isEditDep: action.val };
    case actionTypes.SHOW_DEPARTMENT_LIST:
      return {
        ...state,
        Error: false,
        departmentRecord: action.department,
        isLoading: false,
        isValidName: false,
        isValidNotes: false
      };
    case actionTypes.ADD_DEPARTMENT_SUCCESS:
      return {
        ...state,
        Error: false,
        department: { name: "", notes: "" },
        isLoading: false,
        departmentRecord: [...state.departmentRecord, action.department],
        saving: false,
        errors: {},
        isValidName: false,
        isValidNotes: false
      };
    case actionTypes.EDIT_DEPARTMENT:
      return { ...state, department: action.department, Error: false };
    case actionTypes.UPDATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        Error: false,
        departmentRecord: state.departmentRecord.map(dep =>
          dep.id === (action.department.id || action.department.Id)
            ? { ...dep, ...action.department }  // Update with new data
            : dep
        ),
        isLoading: false
      };
    case actionTypes.CLEAR_FIELDS:
      return {
        ...state,
        department: { name: "", notes: "" },
        Error: false,
        isValidName: false,
        isValidNotes: false
      };
    case actionTypes.DELETE_DEPARTMENT:
      return {
        ...state,
        Error: false,
        departmentRecord: state.departmentRecord.map(dep =>
          dep.id === action.department.id
            ? { ...dep, isActive: false }  // Soft delete: mark as inactive
            : dep
        ),
        isLoading: false
      };
    case actionTypes.DEPARTMENT_ERROR:
      return {
        ...state,
        message: action.payload,
        Error: true,
        isLoading: false
      };
    default:
      return state;
  }
}
